export default "__VITE_ASSET__yGgK4evg__"